import React, { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
import CircularProgress from "components/circularProgress";

// Lazy-loaded components
const SignIn = lazy(() => import("views/SignIn"));
const Unauthorized = lazy(() => import("components/Unauthorized"));
const Dashboard = lazy(() => import("views/Dashboard"));
const SubscriptionManagement = lazy(() => import("views/Subscription"));
const Coupons = lazy(() => import("views/Coupons"));
const MyAccount = lazy(() => import("views/Settings"));
const Recycle = lazy(() => import("views/RecycleBin"));
const Devices = lazy(() => import("views/Device"));
const DeviceDetails = lazy(() => import("views/Device/DeviceDetail"));
const Location = lazy(() => import("views/Location"));
const UserManagement = lazy(() => import("views/User_Management"));
const UserManagementDetails = lazy(() =>
  import("views/User_Management/Details")
);
const Notifications = lazy(() => import("views/Notification"));
const Revenue = lazy(() => import("views/Revenue"));

const RootLayout = lazy(() => import("layouts/RootLayout"));
const SubscriptionDetails = lazy(() => import("views/Subscription/Details"));

const CenteredCircularProgress = () => (
  <div className="loading-container">
    <CircularProgress />
  </div>
);

export const RouteConfig = () => {
  const routesForAuthenticatedOnly = [
    {
      path: "/",
      element: (
        <Suspense fallback={<CenteredCircularProgress />}>
          <RootLayout />
        </Suspense>
      ),
      children: [
        { path: "/dashboard", key: "dashboard", element: <Dashboard /> },
        { path: "/devices", element: <Devices /> },
        { path: "/devices/:id", element: <DeviceDetails /> },
        { path: "/location", element: <Location /> },
        { path: "/user_management", element: <UserManagement /> },
        {
          path: "/user_management/:id",
          element: <UserManagementDetails />,
        },
        { path: "/subscription", element: <SubscriptionManagement /> },
        { path: "/revenue", element: <Revenue /> },
        { path: "/coupons", element: <Coupons /> },
        { path: "/settings", element: <MyAccount /> },
        { path: "/notifications", element: <Notifications /> },
        { path: "/recycleBin", element: <Recycle /> },
        { path: "/devices/:id", element: <DeviceDetails /> },
        { path: "/subscription/:id", element: <SubscriptionDetails /> },
      ],
    },
  ];

  const routesForNotAuthenticatedOnly = [
    {
      path: "/",
      element: (
        <Suspense fallback={<CenteredCircularProgress />}>
          <Outlet />
        </Suspense>
      ),
      children: [
        { path: "/auth/signin", element: <SignIn /> },
        { path: "*", element: <Unauthorized /> },
      ],
    },
  ];

  return { routesForAuthenticatedOnly, routesForNotAuthenticatedOnly };
};
